import React from "react";
import {
  FontWeightStyle,
  HeadingElementTag,
  TextElementTag,
  TextStyle,
} from "./typography-helper";
import classNames from "classnames";

interface TypographyProps {
  /**
   * Font weight
   */
  fontweight?: FontWeightStyle;
  /**
   * Text style
   */
  textStyle?: TextStyle;
  /**
   * Extend classes
   */
  extendClasses?: string;
  /**
   * Content
   */
  children?: React.ReactNode;
}

interface TextProps
  extends TypographyProps,
  React.HtmlHTMLAttributes<HTMLParagraphElement> {
  /**
   * Text type
   */
  type?: TextElementTag;
}

export const Text: React.FC<TextProps> = ({
  fontweight = "400",
  textStyle,
  type = "p",
  extendClasses,
  children,
}) => {
  const Element = type;
  return (
    <Element
      className={classNames({
        [extendClasses as string]: !!extendClasses,
        tfcText: true,
        [`tfcTypography-${fontweight}`]: true,
        [`tfcTypography-${textStyle}`]: !!textStyle,
      })}
    >
      {children}
    </Element>
  );
};

/* Heading */

interface HeadingProps
  extends TypographyProps,
  React.HtmlHTMLAttributes<HTMLHeadingElement> {
  /**
   * Heading element tag
   */
  type?: HeadingElementTag;
}

export const Heading: React.FC<HeadingProps> = ({
  fontweight = "400",
  textStyle,
  extendClasses,
  type = "h2",
  children,
}) => {
  const Element = type;

  return (
    <Element
      className={classNames({
        [extendClasses as string]: !!extendClasses,
        tfcHeading: true,
        [`tfcTypography-${fontweight}`]: true,
        [`tfcTypography-${textStyle}`]: !!textStyle,
        [`tfcTypography-${type}`]: true,
      })}
    >
      {children}
    </Element>
  );
};

const Typography = { Text, Heading };

export default Typography;
